enum ROUTES {
	dataQuality = '/data-quality/:assetId',
	dataSource = '/datasource/:workspaceObjectId',
	dev_only = '/dev_only/:workspaceObjectId',
	utilities = '/utilities/:workspaceObjectId',
}
export default ROUTES;
